// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_zTu","cls2":"download_preflight-cls2_1za download_preflight-cls1_zTu"};